import { LatestCurationFeedPage } from '@services/MarppleShop/renderApp/pages/Curation/LatestCurationFeed/LatestCurationFeed.page.ts';

export const latestCurationFeedRouter = {
  '/@/latest-curation-feed': LatestCurationFeedPage,
};
